import useSWR from 'swr';
import { supabase } from '@/lib/supabase';

// PGRST205 = table/view missing from schema cache, 42P01 = undefined_table, PGRST202 = function missing
export const isMissingObject = (err) => ['PGRST205', 'PGRST202', '42P01'].includes(err?.code) || /Could not find the (table|function)|does not exist/i.test(err?.message || '');

async function probe(tables) {
  for (const t of tables) {
    const { error } = await supabase.from(t).select('*').limit(0);
    if (error) {
      if (isMissingObject(error)) return { state: 'pending', error, table: t };
      // Permission/RLS style errors still prove the object exists
      if (['42501', 'PGRST301'].includes(error.code)) continue;
      return { state: 'error', error, table: t };
    }
  }
  return { state: 'ready' };
}

// Distinguishes: checking → pending (migration not applied) / ready / error
export function useSchemaReady(key, tables) {
  const { data, isLoading } = useSWR(key ? ['schema-ready', key, ...tables] : null, () => probe(tables), { revalidateOnFocus: false, dedupingInterval: 60000 });
  return isLoading || !data ? { state: 'checking' } : data;
}
